import { render, staticRenderFns } from "./GlobalNav.vue?vue&type=template&id=d1452b7e&scoped=true"
import script from "./GlobalNav.vue?vue&type=script&lang=js"
export * from "./GlobalNav.vue?vue&type=script&lang=js"
import style0 from "./GlobalNav.vue?vue&type=style&index=0&id=d1452b7e&prod&scoped=true&lang=scss&ref=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1452b7e",
  null
  
)

export default component.exports